import React from "react";
import { cn } from "@/lib/utils";

interface EmptyStateProps {
  icon?: React.ReactNode;
  title?: string;
  description?: string;
  action?: React.ReactNode;
  className?: string;
  hideOnCollapse?: boolean;
  isCollapsed?: boolean;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  icon,
  title,
  description,
  action,
  className,
  hideOnCollapse = true,
  isCollapsed = false,
}) => {
  if (hideOnCollapse && isCollapsed) {
    return null;
  }

  return (
    <div
      className={cn(
        "px-2 py-4 text-center text-sm text-muted-foreground",
        className
      )}
    >
      {icon && <div className="mb-2 flex justify-center">{icon}</div>}
      {title && <p className="font-medium mb-1">{title}</p>}
      {description && <p className="mb-3">{description}</p>}
      {action && <div>{action}</div>}
    </div>
  );
};
